var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/20/solid';
import { getPeopleActivityFields, processPeopleActivityData } from '@web/components/ItemDetails/utils/peopleActivityTableUtils';
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import Table from '@web/components/layout/Table/Table';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { trpc } from '@web/lib/trpc';
import { isAiButtonDisabled, isInsightsDataEmpty } from '@web/utility';
import { useFilters } from '@web/utility/hooks/useFilters';
import { drivePeopleActivityFields, InsightTypeEnum, SortOrderEnum } from '@workalizer/shared';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
export var PeopleActivity = function () {
    var t = useTranslation().t;
    var _a = useFilters(), itemId = _a.itemId, dateFrom = _a.dateFrom, dateTo = _a.dateTo;
    var _b = useState({
        show: true,
        elementIndex: 1,
        orderByField: drivePeopleActivityFields.views,
        direction: SortOrderEnum.DESC,
        orderByDirection: SortOrderEnum.DESC
    }), sortingOption = _b[0], setSortingOption = _b[1];
    var _c = trpc.drivePeopleActivity.useQuery({
        documentId: itemId !== null && itemId !== void 0 ? itemId : 0,
        dateFrom: dateFrom,
        dateTo: dateTo
    }, {
        enabled: !!itemId,
        keepPreviousData: false
    }), activityData = _c.data, refetch = _c.refetch, isLoading = _c.isLoading, isFetching = _c.isFetching;
    if (isLoading || (isFetching && !activityData)) {
        return _jsx(Loading, {});
    }
    if (!activityData) {
        return _jsx(Loading, {});
    }
    var fields = getPeopleActivityFields(t);
    var columns = __spreadArray([
        {
            title: (_jsxs("div", __assign({ className: "flex items-center gap-1 min-w-[180px]" }, { children: [t('driveItemDetails.peopleActivityTable.person'), (sortingOption === null || sortingOption === void 0 ? void 0 : sortingOption.orderByField) === 'user' &&
                        (sortingOption.direction === 'asc' ? (_jsx(ChevronUpIcon, { className: "h-4 w-4" })) : (_jsx(ChevronDownIcon, { className: "h-4 w-4" })))] }))),
            isVisible: true,
            className: 'w-[180px] cursor-pointer !text-left uppercase',
            orderByField: 'user'
        }
    ], fields.map(function (_a) {
        var title = _a.title, key = _a.key;
        return ({
            title: (_jsxs("div", __assign({ className: "flex items-center gap-1 min-w-[80px]" }, { children: [title, (sortingOption === null || sortingOption === void 0 ? void 0 : sortingOption.orderByField) === key &&
                        (sortingOption.direction === 'asc' ? (_jsx(ChevronUpIcon, { className: "h-4 w-4" })) : (_jsx(ChevronDownIcon, { className: "h-4 w-4" })))] }))),
            isVisible: true,
            className: 'w-[80px] cursor-pointer !text-center uppercase',
            orderByField: key
        });
    }), true);
    var data = processPeopleActivityData(activityData, t, sortingOption);
    return (_jsxs("div", { children: [_jsx(WidgetTitle, { title: t('driveItemDetails.peopleActivity'), description: "widgetTitleDescriptions.itemDetails.drivePeopleActivity", insightType: InsightTypeEnum.documentPeopleActivity, insightsData: activityData, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t('driveItemDetails.peopleActivity'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                        var rows, totalsRow;
                        var _a;
                        var _b;
                        return __generator(this, function (_c) {
                            rows = ((_b = activityData === null || activityData === void 0 ? void 0 : activityData.users) !== null && _b !== void 0 ? _b : []).map(function (user) {
                                var _a;
                                var _b;
                                var base = (_a = {},
                                    _a[t('driveItemDetails.peopleActivityTable.person')] = user.name || user.email,
                                    _a[t('driveItemDetails.peopleActivityTable.department')] = (_b = user.orgUnitTitle) !== null && _b !== void 0 ? _b : '',
                                    _a);
                                fields.forEach(function (_a) {
                                    var key = _a.key, title = _a.title;
                                    base[title] = user[key];
                                });
                                return base;
                            });
                            totalsRow = (_a = {},
                                _a[t('driveItemDetails.peopleActivityTable.person')] = t('driveItemDetails.peopleActivityTable.total'),
                                _a[t('driveItemDetails.peopleActivityTable.department')] = '',
                                _a);
                            fields.forEach(function (_a) {
                                var key = _a.key, title = _a.title;
                                totalsRow[title] = activityData.totals[key];
                            });
                            rows.push(totalsRow);
                            return [2 /*return*/, rows];
                        });
                    }); }, disabled: isAiButtonDisabled(activityData) }) }), _jsx("div", __assign({ className: "relative" }, { children: _jsx(Table, { columns: columns, data: isInsightsDataEmpty(activityData) ? [] : data, striped: true, tableClassName: "min-w-[1180px]", sortingOption: sortingOption, setSortingOption: function (option) {
                        return setSortingOption(__assign(__assign({}, option), { direction: option.direction, orderByDirection: option.orderByDirection }));
                    } }) }))] }));
};
